import { render, staticRenderFns } from "./PresenterOverlay.vue?vue&type=template&id=6dc68aae&scoped=true"
import script from "./PresenterOverlay.vue?vue&type=script&lang=js"
export * from "./PresenterOverlay.vue?vue&type=script&lang=js"
import style0 from "./PresenterOverlay.vue?vue&type=style&index=0&id=6dc68aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc68aae",
  null
  
)

export default component.exports